module.exports = __webpack_public_path__ + "static/media/sf-trial-1.7077de2e.mp3";